import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Decoder } from "@/components/Decoder";
import { HowItWorks } from "@/components/HowItWorks";
import { FupsRepository } from "@/components/FupsRepository";
import { Footer } from "@/components/Footer";
import TapeFrame from "@/pages/TapeFrame";

const Landing = () => (
  <div className="ds-flat">
    <Header />
    <Hero />
    <Decoder />
    <HowItWorks />
    <FupsRepository />
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            border: "2px solid #0A0A0A",
            borderRadius: 0,
            boxShadow: "4px 4px 0 #0A0A0A",
            background: "#F2F0E9",
            color: "#0A0A0A",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: 12,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/tape" element={<TapeFrame />} />
          <Route path="/tape/t/:slug" element={<TapeFrame />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
